import React, { ReactElement } from "react"
import { Dialog } from "@carrotfertility/carotene-core"
import { useIntl } from "react-intl"
import { UpdateRoutingFlowModal } from "../shared/UpdateRoutingFlowModal"
import { useStartRouting } from "../shared/useQueryStartRouting"
import {
  getHasJourneyChangeModalTriggeredThisSession,
  updateHasJourneyChangeModalTriggeredThisSession
} from "#/components/views/modal/utils/localStorageUtils"
import { useJourneyDisplay } from "../hooks/useJourneyDisplay"
import { RoutingFlowType } from "#/components/carrot-plans/types/routingFlowType"

export function JourneyChangeDialogContainer({
  origin,
  setToggleModalFromCta
}: {
  origin: "email" | "cta"
  setToggleModalFromCta?: (open: boolean) => void
}): ReactElement {
  const { shouldShowPostCarrotPlanJourneyDisplay, journeyDataIsLoaded } = useJourneyDisplay()
  const emailLink = origin === "email"
  const clickedLink = origin === "cta"
  const [openJourneyChangeModal, setOpenJourneyChangeModal] = React.useState(false)

  function handleClose(): void {
    setOpenJourneyChangeModal(false)
    if (clickedLink) {
      setToggleModalFromCta(false)
    }
    if (emailLink) {
      updateHasJourneyChangeModalTriggeredThisSession(true)
    }
  }

  React.useEffect(() => {
    if (emailLink && journeyDataIsLoaded) {
      const journeyChangeDialogHasTriggered = getHasJourneyChangeModalTriggeredThisSession()
      const shouldRender = !journeyChangeDialogHasTriggered && shouldShowPostCarrotPlanJourneyDisplay
      setOpenJourneyChangeModal(shouldRender)
    }
    if (clickedLink) {
      setOpenJourneyChangeModal(true)
    }
  }, [
    clickedLink,
    emailLink,
    journeyDataIsLoaded,
    openJourneyChangeModal,
    setOpenJourneyChangeModal,
    shouldShowPostCarrotPlanJourneyDisplay
  ])

  if (!openJourneyChangeModal || !journeyDataIsLoaded) {
    return null
  }

  return <JourneyChangeDialog handleClose={handleClose} />
}

function JourneyChangeDialog({ handleClose }: { handleClose: () => void }): ReactElement {
  const intl = useIntl()
  const header = intl.formatMessage({ defaultMessage: "We've got a few questions..." })
  const { startRouting } = useStartRouting(RoutingFlowType.JOURNEY_CHANGE)
  return (
    <Dialog aria-labelledby="journey-change-modal" scroll="body" open>
      <UpdateRoutingFlowModal header={header} clickGoBack={() => handleClose()} clickUpdateMyAnswers={startRouting} />
    </Dialog>
  )
}
